import SurveyFeedbackByCodeBody from "components/SurveyComponents/SurveyFeedback/SurveyFeedbackBody/SurveyFeedbackByCodeBody";

const SurveyFeedbackByCode = () => {
  return <SurveyFeedbackByCodeBody />;
};

export default SurveyFeedbackByCode;
